<template>
  <div>
    <v-dialog v-model="dialog" persistent width="50%">
      <v-btn dark color="green" slot="activator"><v-icon left>assignment</v-icon> ใบลงเวลาปฏิบัติงาน</v-btn>
      <v-card>
        <v-card-title>
          <span class="subheading teal--text">ใบลงเวลาปฏิบัติงาน</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout>
              <v-flex xs6 md5 d-flex>
                <v-menu
                  ref="menuFromDate"
                  :close-on-content-click="false"
                  v-model="menuFromDate"
                  :nudge-right="40"
                  :return-value.sync="params.fromDate"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    :value="date(params.fromDate)"
                    label="ตั้งแต่วันที่"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="params.fromDate" @input="$refs.menuFromDate.save(params.fromDate)" no-title locale="th-Th"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs6 md5 d-flex>
                <v-menu
                  ref="menuToDate"
                  :close-on-content-click="false"
                  v-model="menuToDate"
                  :nudge-right="40"
                  :return-value.sync="params.toDate"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    :value="date(params.toDate)"
                    label="ถึงวันที่"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="params.toDate" @input="$refs.menuToDate.save(params.toDate)" no-title locale="th-Th"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs6 md4>
                <v-checkbox :label="`ข้อมูล L`" v-model="isLecturer" hide-details class="shrink"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn class="grey white--text" @click.native="close">ปิด</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="blue darken-1 white--text" 
            target="_new" 
            :href="printoutUrl"
            :disabled="!active" 
          > <v-icon left dark>cloud_download</v-icon> ส่งออกข้อมูล</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '@/config/index'
import moment from 'moment'
import swal from 'sweetalert2'

export default {
  props: [ 'sectionSelected', 'subject' ],
  data: () => ({
    active: false,
    dialog: false,
    menuFromDate: null,
    menuToDate: null,
    isOnlyG: false,
    isLecturer: true,
    isMandatory: false,
    reportType: 'LG',
    params: {
      fromDate: null,
      toDate: null
    }
  }),
  computed: {
    ...mapGetters([
      'token'
    ]),
    printoutUrl () {
      return `${config.serverURI}/coursePlans/exportTimesheet?fromDate=${this.params.fromDate}&toDate=${this.params.toDate}&isLecturer=${this.isLecturer}&isOnlyG=${this.isOnlyG}&sectionId=${this.sectionSelected}&access_token=${this.token}&reportType=${this.reportType}&subject=${this.subject.code}`
    },
  },
  methods: {
    close () {
      this.dialog = false
    },
    date (val) {
      return val ? this.$options.filters.formatFullDate(val) : null
    }
  },
  watch: {
    'params': {
      handler (val) {
        console.log('watch fromDate', val.fromDate)
        console.log('watch toDate', val.toDate)
        if( val.fromDate && val.toDate) {
          let fd = moment(val.fromDate)
          let td = moment(val.toDate)
          if(fd.diff(td) > 0) this.params.toDate = this.params.fromDate
          // if(td.diff(fd) < 0) this.params.fromDate = this.params.toDate
          this.active = true
        }
      },
      deep: true
    },
    isOnlyG (val) {
      if(val) {
        this.reportType = 'G'
      } else {
        this.reportType = 'LG'
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/course/coursePlan/filters/timesheetExporter.vue